module.exports = __webpack_public_path__ + "img/split_squat_6.9fde058f.png";